
<div class="_dialog-title">
	<div class="flex-grow-1">{{'add_gratuity' | translate}}</div>
	<button mat-icon-button (click)="cancel()" class="dialog-close-button">
		<mat-icon aria-label="Close Dialog">close</mat-icon>
	</button>
</div>

<div class="_dialog-content" [ngClass]="{'animated fast shake': noTipAlert}" style="min-height:200px;">

	<p class="text-info" *ngIf="$storage.order.autoGratuity">
		{{appService.translate('service_charges_applied', {name: $storage.order.autoGratuity.name})}}: {{$storage.order.autoGratuity.amount | lcurrency:'1.2-2'}}
	</p>

	<div class="mb-4">
		<table style="font-weight: 500;">
			<tr>
				<td>{{(isFullOrderTotal ? 'PO.ORDER_TOTAL' : 'current_payment') | translate}}:</td> <!--'PO.ORDER_TOTAL'-->
				<td style="text-align:right"><div class="ml-3">{{orderTotal | lcurrency:'1.2-2'}}</div></td>
			</tr>
		</table>
	</div>


	<div class="gratuity-rows">
		<!--SEATED GRATUITY-->
		<ng-container *ngIf="tipBehavior == 'P'">
			<button type="button" class="btn-bordered"
					*ngFor="let opt of $storage.gratuities"
					[ngClass]="{'active': slectedGratuity == opt}"
					(click)="setGratuity('p', opt)">
				<div>{{opt}}%</div>
				<div class="info">{{tabitPayService.calculateGratuityFromPercentage(opt, paymentAmount) | lcurrency:currencyFormat}}</div>
			</button>
		</ng-container>
		<!--end SEATED GRATUITY-->
		<!--COURIER GRATUITY-->
		<ng-container *ngIf="tipBehavior == 'A'">
			<button type="button" class="btn-bordered"
					*ngFor="let opt of $storage.gratuities"
					[ngClass]="{'active': slectedGratuity == opt}"
					(click)="setFixedValGratuity(opt)">
				<div>{{opt | lcurrency:currencyFormat}}</div>
			</button>
		</ng-container>
		<!--end COURIER GRATUITY-->
	</div>

	<div class="gratuity-rows">
		<button type="button" (click)="setManualGratuity('v')" style="width:25%;" class="btn-bordered" [ngClass]="{'active': slectedGratuity == 'v'}">
			<span>{{ 'amount' | translate}} {{appService.regionArgs.currency}}</span>
			<div *ngIf="slectedGratuity == 'v'" class="info _lg">{{gratuity.amount | lcurrency:currencyFormat}}</div>
		</button>
		<button type="button" (click)="setManualGratuity('p')" style="width:25%;" class="btn-bordered" [ngClass]="{'active': slectedGratuity == 'p'}">
			<span>{{ 'percent' | translate}} %</span>
			<div *ngIf="slectedGratuity == 'p'" class="info _lg d-flex align-items-center justify-content-center"><span>{{gratuity.percent | number:'1.0-2'}}%</span><span class="ml-2">{{gratuity.amount | lcurrency:currencyFormat}}</span></div>			
		</button>
	</div>

	<div *ngIf="gratuity.amount && $storage.gratuityPAWarning" class="mt-1 text-info text-center font-semi-bold text-xs animated faster slideInUp">
		<div>{{$storage.gratuityPAWarning}}</div>
	</div>
</div>


<div class="_bottom-actions">
	<button mat-button class="_cancel" (click)="continue()" *ngIf="!data.isTipMode">{{'WITHOUT_GRATUITY' | translate}}</button>
	<button mat-button class="_cancel" (click)="continue()" *ngIf="data.isTipMode">{{'Cancel' | translate}}</button>
	<button type="submit" mat-button color="accent" (click)="submit()">{{'continue' | translate}}</button>
</div>

